var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('portal-header'),_c('router-view'),_c('portal-footer'),_c('back-to-top'),_c('contact-float')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }